import { Component } from '@angular/core';
import { TableHeaderParams } from '../../types/common';
import { TooltipIconComponent } from '../tooltip-icon/tooltip-icon.component';
import { NgClass, NgIf } from '@angular/common';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { SortState, SortDirection, SortClickEvent } from '../../../utils/sort-state';
import { GridApi } from 'ag-grid-community'
import { InventoryQualityTableColumns } from '../sites-table/types';
import { AssetVersionPipe } from '../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-table-header-cell',
  imports: [
    NgIf,
    NgClass,
    TooltipIconComponent,
    AssetVersionPipe
  ],
  templateUrl: './table-header-cell.component.html',
  styleUrl: './table-header-cell.component.scss'
})
export class TableHeaderCellComponent implements IHeaderAngularComp {

  protected sort = new SortState();
  private tableApi!: GridApi;
  private field?: InventoryQualityTableColumns;


  protected text?: string;
  protected tooltip?: string;
  protected sortable?: boolean = false;

  agInit(params: TableHeaderParams) {
    this.init(params);
    this.tableApi.addEventListener('sortClick' as any, this.onSortClickEvent.bind(this))
  }

  refresh(params: TableHeaderParams): boolean {
    this.init(params);
    return true;
  }

  private init(params: TableHeaderParams): void {
    this.text = params.displayName;
    this.tooltip = params.tooltip;
    this.sortable = params.sortable;
    this.field = params.field;
    this.tableApi = params.api;
  }

  private onSortClickEvent(event: SortClickEvent): void {
    if (this.field !== event.field)
      this.sort.change(true);
  }

  protected onClick(): void {
    this.sort.change(false);
    this.tableApi.dispatchEvent({
      type: 'sortClick',
      field: this.field,
      direction: this.sort.direction,
    } as any)
  }

  destroy(): void {
    this.tableApi.removeEventListener('sortClick' as any, this.onSortClickEvent);
  }
}
